module.exports = __webpack_public_path__ + "img/advantage-en.b6c71be0.jpg";